
<div :class="{'list-view-filters container': !isFromDashboard}">
  <div class="container">
    <list-view-filter-base
      v-for="filterElement in listView.filterElementsArray"
      :filter-element="filterElement"
      :key="filterElement.id"
    ></list-view-filter-base>

    <advanced-filter
        v-if="isFormability"
        :referencable-control-container="advancedFilterReferencableControlContainer"
        :show-section-divider="listView.hasFilterElements"
    ></advanced-filter>
  </div>
</div>
